var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ viewBox: "0 0 512 512" }, props),
    React.createElement("path", { d: "M412 114c8 0 15 6 15 14v256c0 8-7 14-15 14H14c-8 0-14-6-14-14V128c0-8 6-14 14-14zm86 85c8 0 14 6 14 14v86c0 8-6 14-14 14h-43V199zM335 309c34 12 39-10 11-34l-117-99c-11-10-34-6-35 9l-2 48-95-42c-40-18-46 4-14 34l124 111c10 10 33 6 34-9l2-49z" })
  );
});